import React from 'react';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import SearchIcon from 'material-ui/svg-icons/action/search';
import InfoIcon from 'material-ui/svg-icons/action/info-outline';
import FlatButton from 'material-ui/FlatButton';
import {List, ListItem} from 'material-ui/List';
import Dialog from 'material-ui/Dialog';
import DataFeedStore from '../stores/DataFeedStore';
import DataFeedActions from '../actions/DataFeedActions';
import PrettyJSON from './PrettyJSON.react';
import moment from 'moment';

const selectStyle = {
    textAlign: 'left'
}

const buttonStyle = {
    margin: 12
}

const style = {
    margin: 20,
    textAlign: 'center',
    display: 'inline-block',
    marginBottom: 50,
    height: 500

};

const textFieldStyle = {}

const refreshIndicatorStyle = {
    display: 'inline-block',
    position: 'relative',
};

var Organisation = React.createClass({
    getInitialState: function () {
        var commentsForContractorsOpen = false;

        if (this.props.company.super_contractor_comments) {
            commentsForContractorsOpen = true;
        }

        return {
            super_contractor_comments: '',
            backOnThePile: false,
            neustar_open: false,
            neustar_data: this.props.company.record.neustar_raw_data,
            type_id: 0,
            id: this.props.company.record.id,
            name: this.props.company.record.name,
            organisationId: this.props.company.record.organisation_id,
            loadingNew: DataFeedStore.isLoading(),
            tel: this.props.company.record.tel,
            linkedIn: '',
            hostname: this.props.company.record.hostname,
            companyName: this.props.company.record.end_user_company_name,
            dateTime: moment(this.props.company.record.updated_at).format('dddd, MMM Do YYYY, h:mm:ss'),
            remaining: this.props.company.remaining,
            missingFields: [],
            superContractorComments: this.props.company.record.super_contractor_comments,
            commentsForContractorsOpen: commentsForContractorsOpen,
            missingDataDialogOpen: false,
            complicatedRecordDialog: false,
            isComplicated: false,
            reasonComplicated: '',
            missingData: false,
            ref: {
                name: this.props.company.record.name,
                tel: this.props.company.record.tel,
                type_id: 1,
                linkedIn: '',
                hostname: this.props.company.record.hostname,
                companyName: this.props.company.record.end_user_company_name,
            }
        }
    },
    componentWillReceiveProps: function (nextProps) {
        var commentsForContractorsOpen = false;

        if (nextProps.company.super_contractor_comments) {
            commentsForContractorsOpen = true;
        }

        var newState = {
            neustar_data: nextProps.company.record.neustar_raw_data,
            id: nextProps.company.record.id,
            organisationId: nextProps.company.record.organisation_id,
            name: nextProps.company.record.name,
            tel: nextProps.company.record.tel,
            linkedIn: '',
            hostname: nextProps.company.record.hostname,
            companyName: nextProps.company.record.end_user_company_name,
            type_id: 0,
            loadingNew: DataFeedStore.isLoading(),
            dateTime: moment(nextProps.company.record.updated_at).format('dddd, MMM Do YYYY, h:mm:ss'),
            remaining: nextProps.company.remaining,
            superContractorComments: nextProps.company.super_contractor_comments,
            commentsForContractorsOpen: commentsForContractorsOpen,

            ref: {
                name: nextProps.company.record.name,
                tel: nextProps.company.record.tel,
                linkedIn: '',
                hostname: nextProps.company.record.hostname,
                companyName: nextProps.company.record.end_user_company_name,
                location: `${nextProps.company.record.city}, ${nextProps.company.record.country}`,
                type_id: 1,
            }
        }

        if (this.props.company.id !== nextProps.company.id) {
            newState.complicatedRecordDialog = false;
            newState.isComplicated = false;
            newState.reasonComplicated = '';
            newState.missingDataReason = '';
            newState.missingFields = [];
            newState.missingDataDialogOpen = false;
        }

        this.setState(newState);
    },
    onChangeOrganisationName: function (newVal) {
        this.setState({name: newVal.target.value});
    },
    onChangeWebsite: function (newVal) {
        this.setState({website: newVal.target.value});
    },
    handleSector: function (event, index, value) {
        var newState = {
            type_id: value
        }

        if (value === 7) {
            newState.isComplicated = false
            newState.complicatedRecordDialog = true;
        } else if (value === 9) {
            newState.isComplicated = false;
            newState.reasonComplicated = '';
        }

        this.setState(newState);
    },

    onChangeTel: function (newVal) {
        this.setState({
            tel: newVal.target.value
        });
    },
    onChangeLinkedIn: function (newVal) {
        this.setState({
            linkedIn: newVal.target.value
        });
    },
    onChangeHostname: function (newVal) {
        this.setState({
            hostname: newVal.target.value
        })
    },
    searchOrgName: function () {
        window.open('http://www.google.co.uk/search?q=' + this.state.name, '_blank');
    },
    searchWebsite: function () {
        window.open('http://www.google.co.uk/search?q=' + this.state.website, '_blank');
    },
    searchHostname: function () {
        window.open('http://www.google.co.uk/search?q=' + this.state.hostname, '_blank');
    },
    viewNeustarData: function () {
        this.setState({
            neustar_open: true
        })
    },
    setMissingDataReason: function (event) {
        var missingDataReason = event.target.value;

        if (missingDataReason.trim().length > 0) {
            this.setState({
                valid: true,
                missingDataReason: missingDataReason
            })
        }
    },
    handleClose: function () {
        this.setState({
            neustar_open: false
        })
    },
    handleCloseMissingDataDialog: function () {
        this.setState({
            missingDataDialogOpen: false
        })
    },
    handleCloseComplicatedRecordDialog: function () {
        this.setState({
            complicatedRecordDialog: false
        })
    },
    setComplicatedReason: function (event) {
        var value = event.target.value;

        this.setState({
            reasonComplicated: value,
            isComplicated: true
        });
    },

    closeComplicatedRecord: function () {
        this.setState({
            complicatedRecordDialog: false
        })
    },
    cancelSetComplicatedRecord: function () {
        this.setState({
            type_id: 0,
            complicatedRecordDialog: false
        })
    },
    render: function () {
        var missingFields = this.state.missingFields.map(function (missingField, i) {
            return (
                <p key={i}>The field "{missingField}" is missing</p>
            )
        });

        var neustarData = [];

        if (this.state.neustar_data) {
            neustarData = JSON.parse(JSON.stringify(JSON.parse(this.state.neustar_data)));
        }

        const dialogActions = [
            <FlatButton
                label="Close"
                secondary={true}
                onTouchTap={this.handleClose}/>
        ];

        const complicatedRecordOptions = [

            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.cancelSetComplicatedRecord}
            />,

            <FlatButton
                label="Set Reason"
                primary={true}
                onTouchTap={this.closeComplicatedRecord}
            />

        ];

        const missingDataDialogActions = [

            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.handleCloseMissingDataDialog}
            />,
            <FlatButton
                label="Submit"
                primary={true}
                onTouchTap={this._saveRecordMissingData}
            />
        ];

        const commentsForContractorActions = [

            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this._closeCommentsForContractor}
            />
        ];

        var organisationName = "";

        if (typeof this.state.name !== "undefined") {
            var stringArray = this.state.name.split(" ");

            var returnString = stringArray.map(function (word, i) {
                if (word.indexOf("ftip") === -1) {
                    return word;
                } else {
                    return '';
                }
            })

            organisationName = returnString.join(" ");
        }

        var website = (typeof this.state.website !== "undefined") ? this.state.website : "";
        var sector = this.state.type_id;
        var tel = (this.state.tel) ? this.state.tel : "";

        if (typeof website !== "undefined" && website.trim() === ".") {
            website = "";
        }

        var remaining = (
            <div>
                <h4>{this.state.remaining} records remaining</h4>
            </div>
        );

        var contractorComments = "";

        if (this.state.superContractorComments) {
            contractorComments = this.state.superContractorComments.map(function (comment) {
                return (
                    <p>{comment}</p>
                )
            })
        }

        let refOrgName = (this.state.ref.name) ? this.state.ref.name : "";
        let refHostname = (this.state.ref.hostname) ? this.state.ref.hostname : "";
        let refTel = (this.state.ref.tel) ? this.state.ref.tel : "";
        let refLocation = (this.state.ref.location) ? this.state.ref.location : "";

        var companyRecord = (
            <div className="companyRecord">
                <Card>
                    <CardHeader
                        title={this.state.companyName}
                        subtitle={this.state.dateTime}/>
                    <CardText>
                        <div className="row">
                            <div className="col-md-12">
                                {remaining}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="col-md-4">
                                    <Paper style={style} zDepth={5}>
                                        <TextField
                                            style={textFieldStyle}
                                            value={refOrgName}
                                            disabled={true}
                                            floatingLabelText="Organisation Name"/>

                                        <TextField
                                            style={textFieldStyle}
                                            value={refHostname}
                                            disabled={true}
                                            floatingLabelText="Hostname"/>


                                        <TextField
                                            style={textFieldStyle}
                                            value={refTel}
                                            disabled={true}
                                            floatingLabelText="Telephone"/>

                                        <SelectField value={this.state.ref.type_id} autoWidth={true}
                                                     floatingLabelText="Sector"
                                                     style={selectStyle} disabled={true}>
                                            <MenuItem value={0} primaryText="Select"/>
                                            <MenuItem value={1} primaryText="Company"/>
                                            <MenuItem value={2} primaryText="Education"/>
                                            <MenuItem value={4} primaryText="Crawl Bot"/>
                                            <MenuItem value={5} primaryText="Public"/>
                                            <MenuItem value={6} primaryText="Unknown"/>
                                        </SelectField>

                                        <TextField
                                            style={textFieldStyle}
                                            value={refLocation}
                                            disabled={true}
                                            floatingLabelText="Location"/>

                                    </Paper>

                                </div>

                                <div className="col-md-4">

                                    <Paper style={style} zDepth={5}>

                                        <TextField
                                            style={textFieldStyle}
                                            value={organisationName}
                                            onChange={this.onChangeOrganisationName}
                                            floatingLabelText="Organisation Name"/>

                                        <TextField
                                            style={textFieldStyle}
                                            value={website}
                                            onChange={this.onChangeWebsite}
                                            floatingLabelText="Website"/>

                                        <TextField
                                            style={textFieldStyle}
                                            value={tel}
                                            onChange={this.onChangeTel}
                                            floatingLabelText="Telephone"/>


                                        <SelectField value={sector}
                                                     floatingLabelText="Sector"
                                                     autoWidth={true}
                                                     style={selectStyle}
                                                     onChange={this.handleSector}>
                                            <MenuItem value={0} primaryText="Select"/>
                                            <MenuItem value={1} primaryText="Company"/>
                                            <MenuItem value={2} primaryText="Education"/>
                                            <MenuItem value={3} primaryText="ISP"/>
                                            <MenuItem value={4} primaryText="Crawl Bot"/>
                                            <MenuItem value={5} primaryText="Public"/>
                                            <MenuItem value={6} primaryText="Unknown"/>
                                            <MenuItem value={7} primaryText="For Review"/>
                                        </SelectField>

                                        <div className="clr"></div>
                                        <br/>
                                        <RaisedButton label="Commit" onClick={this._saveRecord} secondary={true}
                                                      style={buttonStyle}/>

                                    </Paper>
                                </div>

                                <div className="col-md-4">
                                    <List>
                                        <ListItem onClick={this.searchOrgName} primaryText="Search Organisation Name"
                                                  leftIcon={<SearchIcon/>}/>
                                        <ListItem onClick={this.searchHostname} primaryText="Search Hostname"
                                                  leftIcon={<SearchIcon/>}/>
                                        <ListItem onClick={this.viewNeustarData} primaryText="View Neustar Data"
                                                  leftIcon={<InfoIcon/>}/>
                                    </List>
                                </div>
                            </div>
                        </div>
                    </CardText>


                </Card>

                <Dialog title="Missing Data" onRequestClose={this.handleCloseMissingDataDialog}
                        actions={missingDataDialogActions} open={this.state.missingDataDialogOpen}>

                    {missingFields}

                    <br/>

                    <TextField
                        fullWidth={true}
                        floatingLabelText="Please explain why record submitted with incomplete data"
                        onChange={this.setMissingDataReason}
                        multiLine={true}
                        rows={4}
                    />
                </Dialog>

                <Dialog
                    title="Raw Data"
                    onRequestClose={this.handleClose}
                    actions={dialogActions}
                    autoScrollBodyContent={true}
                    open={this.state.neustar_open}>

					<pre>
						<PrettyJSON data={neustarData}/>
					</pre>
                </Dialog>

                <Dialog title="Comments for Contractor" onRequestClose={this._closeCommentsForContractor}
                        actions={commentsForContractorActions} open={this.state.commentsForContractorsOpen}>

                    {contractorComments}
                </Dialog>

                <Dialog title="Complicated Record" onRequestClose={this.handleCloseComplicatedRecordDialog}
                        open={this.state.complicatedRecordDialog} actions={complicatedRecordOptions}>

                    <TextField
                        fullWidth={true}
                        floatingLabelText="Reason why record is complicated"
                        onChange={this.setComplicatedReason}
                        multiLine={true}
                        rows={4}
                    />
                </Dialog>

            </div>
        );

        var content = '';

        if (this.state.loadingNew) {
            content = (
                <RefreshIndicator
                    size={50}
                    left={70}
                    top={0}
                    loadingColor={"#FF9800"}
                    status="loading"
                    style={refreshIndicatorStyle}/>
            );

        } else {
            content = companyRecord;
        }

        return (
            <div className="organisation">
                {content}
            </div>
        )
    },

    _closeCommentsForContractor: function () {
        this.setState({
            commentsForContractorsOpen: false
        })
    },
    _saveRecordMissingData: function () {
        if (typeof this.state.missingDataReason === "undefined") {

            alert("You must set a missing data reason");

            return false;
        }

        DataFeedActions.setLoading(true);

        DataFeedActions.editOrganisation({

            id: this.state.id,
            storedValue: this.state
        });
    },
    _saveRecord: function () {
        var required = [
            'name',
            'tel',
            'website'
        ]

        var displayFieldNames = {
            name: 'Organisation Name',
            tel: 'Telephone Number',
            website: 'Website'
        }

        let valid = true;

        let missingVals = [];

        required.map(function (val, i) {

            if (typeof this.state[val] === "undefined" ||
                !this.state[val] ||
                this.state[val].trim() === "") {

                valid = false;

                missingVals.push(displayFieldNames[val]);
            }

        }.bind(this));

        this.setState({
            website: ''
        });

        if (!valid && !this.state.isComplicated && this.state.type_id !== 6) {
            this.setState({
                missingDataDialogOpen: true,
                missingData: true,
                missingFields: missingVals
            })
        } else {
            this.setState({
                missingData: false,
                missingDataDialogOpen: false,
            })

            DataFeedActions.setLoading(true);

            DataFeedActions.editOrganisation({
                id: this.state.organisationId,
                recordId: this.state.id,
                storedValue: this.state
            });
        }
    }
});

export default Organisation;



// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/components/Organisation.react.js